import { render, staticRenderFns } from "./CreateComponent.vue?vue&type=template&id=793f980d&"
import script from "./CreateComponent.vue?vue&type=script&lang=js&"
export * from "./CreateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports